import React from "react";
import { Helmet } from "react-helmet-async";
import { canonicalUrl } from "../siteConfig";

export default function SeoAuditToolPage() {
  return (
    <div className="app page-grid">
      <Helmet>
        <title>Technical SEO & Visibility Scanner | OptiSiteSEO</title>
        <meta
          name="description"
          content="Use OptiSiteSEO to scan technical SEO, technical visibility, discoverability, indexing, crawlability, performance, and measurement signals."
        />
        <link rel="canonical" href={canonicalUrl("/seo-audit-tool")} />
      </Helmet>

      <section className="card section">
        <p className="eyebrow">Technical SEO visibility scanner</p>
        <h1>A faster way to produce technical SEO visibility reports</h1>
        <ul className="bullets">
          <li>Prioritized technical SEO and visibility findings, not giant checklists</li>
          <li>Indexing, crawlability, metadata, and performance signals</li>
          <li>Operator-ready language with implementation impact</li>
        </ul>
        <div className="cta-row">
          <a className="primary" href="/app/index.html">
            Run Free SEO Scan
          </a>
          <a className="secondary" href="/demo/index.html">
            See a sample
          </a>
        </div>
      </section>
    </div>
  );
}
